import React, {useContext, useRef, useState} from "react";
import axios from "axios";
import config from "../../../config";
import KSMPopover from "../../common/Popovers";
import {
    FSAselectedItemCannotAddedMessageKey,
    mainMessages,
    selectedItemCannotAddedKey,
} from "../../../assets/text/MultilingualText";
import {CartIcon} from "../../common/icons";
import UserContext from "../../common/UserContext";
import {GeneralContext, SearchProductContext, SelectedProductContext} from "../FSARequestLicenseContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {OverdraftModal} from "./OverdraftModal";
import moment from "moment";
import {addDays} from "@progress/kendo-date-math";

export const CartCell = props => {
    const {
        siteLanguageDefault,
        accessToken
    } = useContext(UserContext);

    const {
        setIsLoading,
        headerInfo,
        setHeaderInfo,
        alreadyOverDraft,
        uniqueID,
        licenseStartDateKey,
        licenseEndDateKey,
        minDate,
        maxDate,
        preprocessNewProducts,
        setShowSecondGenericError,
    } = useContext(GeneralContext);

    const {
        searchedProducts,
        setSearchedProducts,
    } = useContext(SearchProductContext);

    const {
        selectedProducts,
        setSelectedProducts
    } = useContext(SelectedProductContext);

    const localization = useLocalization();

    let style
    const selectedLicenseType = props.dataItem.license_type.filter(lt => lt.selected)

    let minEndDate = addDays(props.dataItem[licenseStartDateKey], headerInfo['minimum_duration'])
    if (minEndDate > maxDate) {
        minEndDate = maxDate
    }

    let inputValid = props.dataItem.quantity > 0 &&
        selectedLicenseType[0].text !== 'Select' &&
        props.dataItem[licenseStartDateKey] >= minDate &&
        props.dataItem[licenseStartDateKey] < props.dataItem[licenseEndDateKey] &&
        props.dataItem[licenseEndDateKey] >= minEndDate &&
        props.dataItem[licenseEndDateKey] <= maxDate

    const isError = props.dataItem['exceedError']
    if (isError) {
        style = {
            color: 'var(--color-alert-danger-base)',
            cursor: 'default',
        }
    } else {
        if (inputValid) {
            style = {
                color: 'var(--keysight-secondary)',
                cursor: 'pointer'
            }
        } else { //invalid qty or license type
            style = {
                color: '#9c9c9c',
                cursor: 'default',
            }
        }

    }

    const anchor = useRef(null);
    const [popoverShow, setPopoverShow] = useState(false)

    const onMouseOver = () => {
        if (isError) setPopoverShow(true);
    };

    //Remove popover on mouse leave
    const onMouseOut = (ev) => {
        let isChildEl = ev.currentTarget.contains(ev.relatedTarget);
        if (!isChildEl) setPopoverShow(false);
    };

    const addToCart = (ignoreOverdraft) => {
        setShowOverdraftModal(false)
        setShowSecondGenericError(false)

        if (!inputValid) {
            return null;
        }

        setIsLoading(true)

        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };

        let products = JSON.parse(JSON.stringify(props.dataItem));
        products.status = "SELECTED"
        products.license_start_date = moment(products[licenseStartDateKey]).format('YYYY-MM-DD HH:mm:ss')
        products.license_end_date = moment(products[licenseEndDateKey]).format('YYYY-MM-DD HH:mm:ss')
        delete products[uniqueID]

        ignoreOverdraft = ignoreOverdraft || alreadyOverDraft ? 'Y' : 'N'

        let data = {
            "module": "FSA",
            "sub_module": "CART",
            "action": "SAVE",
            "input_json": {
                "fsa_id": headerInfo.fsa_id,
                "ignore_overdraft": ignoreOverdraft,
                "products": [products]
            }
        }

        axios.post(
            config.fsa_request_license.CART,
            data,
            {headers: headers}
        )
            .then(response => {
                //update budget pools
                const data = response.data || {};
                let newHeaderInfo = data['header_info']
                setHeaderInfo(newHeaderInfo)

                let newItem = data['cart_items'][0]
                newItem = preprocessNewProducts(newItem, newHeaderInfo, 'SELECTED')
                setSelectedProducts([...selectedProducts, newItem]);

                //reset added searched product
                const searchIndex = searchedProducts.findIndex(item => item[uniqueID] === props.dataItem[uniqueID])
                searchedProducts[searchIndex].quantity = null
                for (const license of searchedProducts[searchIndex].license_type) {
                    license.selected = false
                }
                if (searchedProducts[searchIndex].license_type.length === 1) {
                    searchedProducts[searchIndex].license_type[0].selected = true
                } else {
                    searchedProducts[searchIndex].license_type.unshift({
                        type: "Select",
                        selected: true,
                        base_price: 0,
                        text: "Select"
                    })
                }
                searchedProducts[searchIndex].license_type = JSON.parse(JSON.stringify(searchedProducts[searchIndex].license_type))
                setSearchedProducts([...searchedProducts])
                setShowOverdraftModal(false)
            })
            .catch(error => {
                console.log("ERROR: Failed to add to cart", error);
                let errorCode = error?.response?.data?.error_code;
                if (errorCode === 'MOD_FSA_163') { //overdraft error
                    setShowOverdraftModal(true)
                } else if (errorCode === 'MOD_FSA_164') { // no more budget
                    let newSearchedProducts = searchedProducts.map(item => {
                        if (item[uniqueID] === props.dataItem[uniqueID]) {
                            item['exceedError'] = true
                        }
                        return item
                    })
                    setSearchedProducts(newSearchedProducts)
                } else (
                    setShowSecondGenericError(true)
                )
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const [showOverdraftModal, setShowOverdraftModal] = useState(false)

    return (
        <td>
            <div style={{display: 'flex', alignItems: 'center'}}>
                {isError && (
                    <KSMPopover
                        show={popoverShow}
                        anchor={anchor.current}
                        position={'left'}
                        type={'error'}
                        style={{
                            maxWidth: '27rem'
                        }}
                        message={<div>
                            <b>{localization.toLanguageString(selectedItemCannotAddedKey, mainMessages[siteLanguageDefault][selectedItemCannotAddedKey])}</b>
                            <br/>
                            {localization.toLanguageString(FSAselectedItemCannotAddedMessageKey, mainMessages[siteLanguageDefault][FSAselectedItemCannotAddedMessageKey])}
                        </div>}
                    />
                )}
                <div ref={anchor} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
                    <CartIcon
                        className={'ksm-grid-icon'}
                        style={style}
                        onClick={() => {
                            addToCart(false)
                        }}
                    />
                </div>
            </div>
            {showOverdraftModal && (
                <OverdraftModal
                    modalType={'SEARCHED'}
                    setShowModal={setShowOverdraftModal}
                    confirmationAction={() => {
                        addToCart(true)
                    }}
                />
            )}

        </td>

    )

}